export default __webpack_public_path__ + "static/media/header.50d6b374.jpg";